var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataCircle"},[_c('div',{style:({height:_vm.calcHeight+'px',width:_vm.calcWidth}),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }